import modalStyles from '../../components/modal/modal.module.scss';
import React, {useCallback} from 'react';
import {useClickOutside} from '../../support/use_click_outside.ts';
import {Avatar} from '../../components/avatar/avatar.tsx';
import {Size} from '../../enums/size.ts';
import {FailureIndicatorType} from '../../gql/pwa/graphql.ts';

interface OwnProps {
    onCloseModal: () => void;
    indicator: FailureIndicatorType;
}

export function FaultModal(props: OwnProps) {
    const ref = React.useRef<HTMLDivElement | null>(null);

    const {onCloseModal} = props;
    const closeModalCallback = useCallback(() => {
        onCloseModal();
    }, [onCloseModal]);
    useClickOutside(ref, closeModalCallback);

    return (
        <div className={modalStyles.modal_backdrop}>
            <div className={modalStyles.modal}>
                <div className={modalStyles.modal_dialog} ref={ref}>
                    <div className={modalStyles.modal_header}>
                        <span />
                        {/*Todo: make close work in right context of the modal*/}
                        <button
                            type="button"
                            onClick={(e) => {
                                e.stopPropagation();
                                onCloseModal();
                            }}
                        >
                            <i className="fa-light fa-close"></i>
                        </button>
                    </div>
                    <div className={modalStyles.modal_body}>
                        <Avatar
                            size={Size.Large}
                            src={props.indicator.image_url}
                            name={''}
                            imageSize={'half'}
                            darkBackground={true}
                        />
                        <p>{props.indicator.description}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
